import React from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import HeaderBar from './HeaderBar/HeaderBar';
import TopBar from './TopBar/TopBar';
import SiderBar from './SiderBar/SiderBar';
import FooterBar from './FooterBar/FooterBar';
import FooterBarB from './FooterBar/FooterBarB';
import { getSiderMenu } from '../../routes/menuUtils';
import { selectRoute } from '../../routes/routeUtils';
import { getScrollTop } from '../../utils/utils';

const { Content } = Layout;

const mapStateToProps = (state) => {
  return {
    menuList: state.root.menuData,
  };
};

class MainLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuList: this.props.menuList || [],
      siderData: getSiderMenu(this.props.menuList, `/${this.props.history.location.pathname.split('/')[1]}`) || {},
      siderWidth: 200,
      collapsed: false,
      siderTopBase: 96,
      siderTop: 96,
      isHeaderFixed: false,
    };
  }

  componentWillReceiveProps(nextprops) {
    this.setState({
      menuList: nextprops.menuList || [],
      siderData: getSiderMenu(this.props.menuList, `/${this.props.history.location.pathname.split('/')[1]}`) || {},
    });
    console.log(getSiderMenu(this.props.menuList, `/${this.props.history.location.pathname.split('/')[1]}`) || {});
  }

  componentDidMount() {
    this.handleScrollChange();
  }

  handleScrollChange = () => {
    window.onscroll = (e) => {
      const top = getScrollTop();
      if (top < 31) {
        this.setState({
          siderTop: this.state.siderTopBase - top,
          isHeaderFixed: false,
        });
      } else if (!this.state.isHeaderFixed) {
        this.setState({
          isHeaderFixed: true,
          siderTop: 64,
        });
      }
    };
  }

  handleHeaderClick = (key) => {
    this.setState({ siderData: getSiderMenu(this.props.menuList, key) });
  }

  handleSiderToggle = (collapsed) => {
    this.setState({
      siderWidth: collapsed ? 80 : 200,
      collapsed,
    });
  };

  render() {
    const RouteData = selectRoute(this.props.menuList);
    // const isShowSider = this.state.siderData.siderList.length !== 0 && RouteData[this.props.location.pathname];
    const isShowSider = this.state.siderData.siderList.length !== 0;

    return (
      <div className="bill99">
        <Layout>
          <HeaderBar
            history={this.props.history}
            menuList={this.state.menuList}
            onClick={(key) => this.handleHeaderClick(key)}
            isHeaderFixed={this.state.isHeaderFixed}
          />
          <Content>
            {
              <Layout style={{
                position: 'relative',
                // backgroundColor: '#fff',
                minHeight: `${window.screen.availHeight - 300}`,
                margin: `${isShowSider ? 0 : '24px 75px'}`,
                paddingLeft: `${isShowSider ? `${this.state.siderWidth}px` : 0}`,
              }}
              >
                <SiderBar
                  history={this.props.history}
                  title={this.state.siderData.name}
                  siderList={this.state.siderData.siderList}
                  isShow={isShowSider}
                  onToggle={this.handleSiderToggle}
                  style={{ top: `${this.state.siderTop}px` }}
                />
                {this.props.children}
              </Layout>
            }
          </Content>
          {
            isShowSider ?
              <FooterBarB
                style={{
                  paddingLeft: `${this.state.collapsed ? 80 : 200}px`,
                }}
              />
              :
              <FooterBar />
          }
        </Layout>
      </div>
    );
  }
}

export default connect(mapStateToProps)(MainLayout);



// WEBPACK FOOTER //
// ./src/views/MainLayout/MainLayout.jsx